module.exports = __webpack_public_path__ + "img/default.259ede4c.png";